import { useCallback, useState } from "react"

/**
 * Une image distante qui n'a pas pu se charger. Les photos servies par le backend sont des adresses
 * S3 signées pour 30 minutes, et les comptes enregistrés sur l'appareil les gardent telles quelles :
 * passé ce délai, l'image échoue et le composant doit retomber sur son repli plutôt que laisser un
 * disque vide.
 *
 * L'échec est retenu POUR CETTE ADRESSE : une nouvelle adresse (signature renouvelée) est retentée,
 * sans effet à remettre à zéro.
 */
export function useFailedImage(uri: string | undefined): { failed: boolean; onError: () => void } {
    const [failedUri, setFailedUri] = useState<string | null>(null)
    const onError = useCallback(() => setFailedUri(uri ?? null), [uri])
    return { failed: uri != null && failedUri === uri, onError }
}
